export function wrapAPIErrorsInArray(errors) {
    let result = {}
    for (const key in errors) {
        if (Object.prototype.hasOwnProperty.call(errors, key))
            result[key] = [errors[key]]
    }
    return result
}

export const SESSION_TYPE = new Map([
    ["SKY_ROOM", "اسکای‌ روم"],
    ["OFFLINE", "آفلاین"],
    ["STATIC", "لینک اختصاصی"],
    ["BBB", "بیگ‌بلو‌باتن"],
]);

export const GRADES = new Map([
    ["GRADE_SEVEN", "هفتم"],
    ["GRADE_EIGHT", "هشتم"],
    ["GRADE_NINE", "نهم"],
    ["GRADE_TEN", "دهم"],
    ["GRADE_ELEVEN", "یازدهم"],
    ["GRADE_TWELVE", "دوازدهم"],
    ["GRADE_GRADUATED", "فارغ التحصیل"],
]);

export const GRADES_OPTIONS = [...GRADES.entries()].map(([key, value]) => {
    return {label: value, value: key}
})

export const WEEKDAYS = new Map([
    ["SATURDAY", "شنبه"],
    ["SUNDAY", "یکشنبه"],
    ["MONDAY", "دوشنبه"],
    ["TUESDAY", "سه‌شنبه"],
    ["WEDNESDAY", "چهارشنبه"],
    ["THURSDAY", "پنجشنبه"],
    ["FRIDAY", "جمعه"],
]);

export const WEEKDAYS_OPTIONS = [...WEEKDAYS.entries()].map(([key, value]) => {
    return {label: value, value: key}
})

export const SESSION_TYPES = new Map([
    ["SKY_ROOM", "اسکای روم"],
    ["OFFLINE", "آفلاین"],
    ["STATIC", "لینک اختصاصی"],
    ["BBB", "بیگ‌بلو‌باتن"],
]);

export const SESSION_TYPES_OPTIONS = [...SESSION_TYPES.entries()].map(([key, value]) => {
    return {label: value, value: key}
})

export const EXAM_TYPES = new Map([
    ["DEFAULT", "سوال به سوال"],
    ["ANSWER_SHEET", "پاسخنامه"],
]);

export const EXAM_TYPES_OPTIONS = [...EXAM_TYPES.entries()].map(([key, value]) => {
    return {label: value, value: key}
})

export const PRODUCT_STATUS = new Map([
    ["0", "غیرفعال"],
    ["1", "فعال"],
]);

export const PRODUCT_STATUS_OPTIONS = [...PRODUCT_STATUS.entries()].map(([key, value]) => {
    return {label: value, value: key}
});

export function productStatusStringToUI(status) {
    return PRODUCT_STATUS.get((status ? "1" : "0"))
}

export const RANDOMIZE_QUESTION = new Map([
    ["0", "به ترتیب"],
    ["1", "تصادفی"],
]);

export const RANDOMIZE_QUESTION_OPTIONS = [...RANDOMIZE_QUESTION.entries()].map(([key, value]) => {
    return {label: value, value: key}
})

export const QUESTION_TYPES = new Map([
    ["MULTI_ANSWER", "چندگزینه‌ای تک‌انتخابی"],
    ["MULTI_CHOICE", "چندگزینه‌ای چندانتخابی"],
    ["DETAILED", "تشریحی"],
]);

export const QUESTION_TYPES_OPTIONS = [...QUESTION_TYPES.entries()].map(([key, value]) => {
    return {label: value, value: key}
})

export const ACCEPTABLE_PERFORMANCES_TYPES = new Map([
    ["0", "ندارد"],
    ["1", "دارد"],
]);

export const ACCEPTABLE_PERFORMANCES_TYPES_OPTIONS = [...ACCEPTABLE_PERFORMANCES_TYPES.entries()].map(([key, value]) => {
    return {label: value, value: key}
})

export const REGULAR_WEEKLY_SCHEDULE_TYPES = new Map([
    ["0", "ندارد"],
    ["1", "دارد"],
]);

export const REGULAR_WEEKLY_SCHEDULE_TYPES_OPTIONS = [...REGULAR_WEEKLY_SCHEDULE_TYPES.entries()].map(([key, value]) => {
    return {label: value, value: key}
})

export const OBEDIENCE_TYPES = new Map([
    ["0", "ندارد"],
    ["1", "دارد"],
]);

export const OBEDIENCE_TYPES_OPTIONS = [...OBEDIENCE_TYPES.entries()].map(([key, value]) => {
    return {label: value, value: key}
})

export const CONSULTATION_EXAM_TYPES = new Map([
    ["INTERNAL", "داخلی"],
    ["INSTITUTES", "مؤسسات"],
]);

export const CONSULTATION_EXAM_TYPES_OPTIONS = [...CONSULTATION_EXAM_TYPES.entries()].map(([key, value]) => {
    return {label: value, value: key}
})

export const SCHOOL_SUSPENDED_TYPES = new Map([
    ["0", "فعال"],
    ["1", "غیر‌فعال"],
]);

export const SCHOOL_SUSPENDED_TYPES_OPTIONS = [...SCHOOL_SUSPENDED_TYPES.entries()].map(([key, value]) => {
    return {label: value, value: key}
})

export function sessionTypeStringToUI(type) {
    return SESSION_TYPE.get(type)
}

export function gradeStringToUI(grade) {
    return GRADES.get(grade)
}

export function sanitizeObjectFromSchema(obj, schema) {
    const sanitized = {}
    for (const p in schema)
        sanitized[p] = (p in obj ? obj : schema)[p];
    return sanitized
}

export function hmToSecondsOnly(str) {
    if (!str)
        return null;

    let p = str.split(':'),
        s = 0, m = 1;

    while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }

    return s * 60;
}

export function secondsToHm(totalSeconds) {
    if (!totalSeconds)
        return null

    const hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    const minutes = Math.floor(totalSeconds / 60);

    return `${hours}:${minutes}`
}

export function secondsToHms(totalSeconds) {
    if (!totalSeconds)
        return null

    const hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${hours}:${minutes}:${seconds}`
}

export function formatDate(iso8601Date) {
    if (!iso8601Date)
        return null
    return new Intl.DateTimeFormat('fa-IR').format(new Date(iso8601Date))
}

export function formatUtcDate(iso8601Date) {
    if (!iso8601Date)
        return null
    return new Intl.DateTimeFormat().format(new Date(iso8601Date))
}

export function dateToDay(date) {
    if (!date)
        return null
    return new Intl.DateTimeFormat('fa-IR', {weekday: "short"}).format(new Date(date))
}

export function formatDatetime(iso8601Date) {
    if (!iso8601Date)
        return null
    return new Intl.DateTimeFormat('fa-IR', {dateStyle: 'short', timeStyle: 'short'}).format(new Date(iso8601Date))
}


export function formatTime(iso8601Date) {
    if (!iso8601Date)
        return null
    return new Intl.DateTimeFormat('fa-IR', {timeStyle: 'short'}).format(new Date(iso8601Date))
}


export function createUUID(){
    let dt = new Date().getTime();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

export function separateComma(val) {
    let sign = 1;
    if (val < 0) {
        sign = -1;
        val = -val;
    }

    let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString();
    let len = num.toString().length;
    let result = '';
    let count = 1;

    for (let i = len - 1; i >= 0; i--) {
        result = num.toString()[i] + result;
        if (count % 3 === 0 && count !== 0 && i !== 0) {
            result = ',' + result;
        }
        count++;
    }

    if (val.toString().includes('.')) {
        result = result + '.' + val.toString().split('.')[1];
    }

    return sign < 0 ? '-' + result : result;
}